export const shouldBeFormal = ({ organization: { type } }) =>
  ["pos", "brand"].indexOf(type) !== -1;
